import { useSearchParams } from 'react-router-dom';

import { Module } from '@app/models/users';
import { OrdersViewType } from '@app/store/currentSessionReducer/interfaces';

import { ALL_TAB, MODULE_TABS, OrdersTab } from '../interfaces';

const parseTab = (value: string | null): OrdersTab =>
  MODULE_TABS.includes(value as Module) ? (value as Module) : ALL_TAB;

export const useOrdersSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const update = (changes: Record<string, string | undefined>) => {
    const params = new URLSearchParams(searchParams);
    Object.entries(changes).forEach(([key, value]) => (value ? params.set(key, value) : params.delete(key)));
    params.set('current', '1');
    setSearchParams(params, { replace: true });
  };

  return {
    tab: parseTab(searchParams.get('tab')),
    view: searchParams.get('view') === OrdersViewType.BOARD ? OrdersViewType.BOARD : OrdersViewType.LIST,
    update,
  };
};
